import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';

@Component({
    selector: 'app-pagenotfound',
    templateUrl: './pagenotfound.component.html',
    styleUrls: ['./pagenotfound.component.css'],
})
export class PageNotFoundComponent implements OnInit {
    constructor(private appComponent: AppComponent) {
        this.appComponent.tituloContenido = 'Página no encontrada';
    }

    ngOnInit(): void {}
}
